import PropertyTransaction from '@/components/features/sold-property/models/PropertyTransaction';
import NewListingSoldApiService from '@/components/features/sold-property/api/NewListingSoldApiService';
import routes from '@/constants/routes';
import PropertyPathHelper from '@/utils/PropertyPathHelper';

// @vue/component
const ActiveListingMixin = {
  data() {
    return {
      activeListingDto: null,
    };
  },
  computed: {
    soldPropertyAddressId() {
      return PropertyPathHelper.parseIdFromParam(this.$route.params.id);
    },
    activeListingTransaction() {
      return this.activeListingDto && new PropertyTransaction(this.activeListingDto);
    },
    activeCardDescription() {
      return `This home is listed for ${this.activeListingTransaction.formattedPrice}`;
    },
    activeListingLink() {
      return `${routes.listings}/${this.activeListingTransaction.listingId}`;
    },
  },
  async mounted() {
    await this.fetchActiveLink();
  },
  methods: {
    async fetchActiveLink() {
      this.activeListingDto = await NewListingSoldApiService
        .getActiveByAddressId(this.soldPropertyAddressId)
        .catch(() => null);
    },
  },
};

export default ActiveListingMixin;
